import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1a424a10")

_pushScopeId("data-v-1a424a10")
const _hoisted_1 = /*#__PURE__*/_createVNode("span", { class: "question-mark text text--accent-gray-a text--size-27 text--medium" }, "?", -1)
const _hoisted_2 = { class: "flex flex--v flex--valign-c text text--size-18 text--height-24 text--primary-b text--medium text--center" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_GenericModal = _resolveComponent("GenericModal")

  return (_openBlock(), _createBlock("div", {
    class: "help-button",
    onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.openModal && _ctx.openModal(...args)), ["stop"]))
  }, [
    _hoisted_1,
    (_ctx.modalOpen)
      ? (_openBlock(), _createBlock(_component_GenericModal, {
          key: 0,
          onClosed: _ctx.closeModal
        }, {
          title: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$trans(_ctx.title)), 1)
          ]),
          content: _withId(() => [
            _createVNode("div", _hoisted_2, _toDisplayString(_ctx.$trans(_ctx.title + _ctx.extra)), 1)
          ]),
          _: 1
        }, 8, ["onClosed"]))
      : _createCommentVNode("", true)
  ]))
})